import ApiResourceManager from '../ApiResourceManager';

// The files of the platform agent's chats (docs/platform-agent/contracts.md §8), on the agent itself
// (VITE_PLATFORM_AGENT_URL): use with useApiClient({ baseUrl: import.meta.env.VITE_PLATFORM_AGENT_URL, autoLogOut: false }),
// which sends the person's login and on-behalf-of headers as the panel's chat does (§1). Uploads don't go through here:
// @vercel/blob/client's upload() sends them straight to the store, signed by the agent's POST /uploads.
export default class PlatformAgentFilesManager extends ApiResourceManager {
  // A file of a chat the person may see (an upload, a shop screenshot) as a Blob; 403 / 404 otherwise.
  file = (pathname) =>
    this.request({
      method: 'GET',
      url: '/files',
      params: { pathname },
      headers: { Accept: '*/*' },
      responseType: 'blob',
    });

  // The chat's history (§6 GET /chats/{id}: `{ chat, events }`), for the files its messages carried (§8).
  chatHistory = (id) =>
    this.request({
      method: 'GET',
      url: `/chats/${encodeURIComponent(id)}`,
    });
}
